import React, { Component } from 'react';
import Cookies from "universal-cookie";
import {connect} from 'react-redux';
import DepartmentNameSearch from './departmentNameSearch'
import DepartmentIpSearch from './departmentIpSearch'
import DepartmentNetsList from './departmentNetsList'

class Ipaddressplan extends Component {
constructor(props){
  super(props)
  this.customername=this.customername.bind(this)
  this.state = { clientip: '', clientip:'', customername:'' }

}


componentDidMount(){
  fetch('http://ocnit.tula.ru/api/req.php',

      {
    method: 'POST',
    headers: new Headers({
             'Content-Type': 'application/x-www-form-urlencoded',

    }),

    body: "action=iprequest"

      }    )
      .then((response)=>response.text())

        .then((answerpost)=>{


                    this.setState({clientip:answerpost})

        })

}

customername(customername){
  this.setState({customername:customername})
}

render(){
  const { clientip, customername } = this.state
  const {auth} = this.props

  return (


      <div>
        <div style={{'padding-top': '12px',  'padding':'20px'}}>
        {auth ?
          <div>

                <DepartmentNameSearch auth={auth} callback={this.customername}/>
                <DepartmentIpSearch callback={this.customername}/>
          </div>
          :
          <div className='red'>Доступ к разделу ограничен. Необходима авторизация.</div>
        }

        {customername ?
          <div className='centerbig'>{customername}
              <DepartmentNetsList customer={customername}/>
          </div>
          :
          <div>
        Определенный сервером IP адрес:

                <p className='boldbig'>{clientip}</p>

              Согласно данным адресного плана ТулГУ данный адрес закреплен за следующим подразделением:
              <p className='bold'>нет данных</p>и описан ответственным следующим образом:
              <p className='bold'>нет данных</p>
              <br/>
              Если Вы находитесь в сети ТулГУ, а по одному из параметров видите сообщение "нет данных" или данные не соответствуют действительности, Вам необходимо обратиться к ответственному по Вашему подразделению или в ОЦНИТ.
            :
            </div>
        }

        </div>
      </div>
  )
}
}

export default connect(
  state => ({
    auth:state.auth
  })
)(Ipaddressplan)
